module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/favorites-7087804132d073562bde39a7d2397dd2.png";